import clsx from 'clsx';
import type { ReactNode } from 'react';
import { DiJira, DiTrello } from 'react-icons/di';
import { LuKanban } from 'react-icons/lu';

import { getProviderCapabilities, ProviderId } from '../../entities/provider';

const PROVIDER_ICON: Record<ProviderId, ReactNode> = {
  jira: <DiJira />,
  trello: <DiTrello />,
  standalone: <LuKanban className="p-px" />,
};

interface ProviderBadgeProps {
  provider: ProviderId;
  className?: string;
}

export function ProviderBadge({ provider, className }: ProviderBadgeProps) {
  const { label } = getProviderCapabilities(provider);
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full bg-base-300/60 px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide text-base-content/70',
        className,
      )}
    >
      <span className="text-sm leading-none">{PROVIDER_ICON[provider]}</span>
      {label}
    </span>
  );
}
